interface RadioProps {
	checked: boolean
}

export const Radio = ({ checked }: RadioProps) => {
	if (checked) {
		return (
			<div className="flex h-4 w-4 items-center justify-center rounded-full border border-solid border-[var(--border-brand,#554bfd)] bg-[var(--bg-brand,#554bfd)] shadow-[0px_1px_1px_rgba(16,24,40,0.05)]">
				<div className="h-2 w-2 rounded-full bg-white" />
			</div>
		)
	}
	return (
		<div className="h-4 w-4 rounded-full border border-solid border-[var(--border-default,#e1e1e1)] bg-[rgb(var(--cg-surface))] shadow-[0px_1px_2px_rgba(16,24,40,0.05)]" />
	)
}
